import { get, isFunction } from 'lodash';
import { connect } from 'react-redux';
import { BLOG_APP_ID, SANTA_MEMBERS_APP_ID } from '@wix/communities-universal/dist/src/constants/appsConfig';
import ExternalLink from '../../components/link/external-link';
import MembersAreaLink from '../../components/link/members-area-link';
import { navigateToBlogOrPostPage } from '../navigate-to-section';
import Wix from '../wix-sdk-polyfill';
import { debug } from '../debug';
import InternalLink from '../../components/link/internal-link';

const MEMBERS_SECTION_APP_ID = '14dbefd2-01b4-fb61-32a7-3abd44da4908';
const SETTINGS_SECTION_APP_ID = '14f25dc5-6af3-5420-9568-f9c5ed98c9b1';
const NOTIFICATIONS_SECTION_APP_ID = '14f25d9b-33f4-ec0a-9568-f9c5ed98c9b1';

export default {
  Link: InternalLink,
  MembersLink: connect(() => ({
    appDefinitionId: MEMBERS_SECTION_APP_ID,
    sectionId: 'all_members',
    to: '/',
    renderHref: false,
  }))(ExternalLink),
  ProfileLink: connect(undefined, (dispatch, { user, onClickExtension }) => ({
    onClick: (event) => {
      event.preventDefault();
      event.stopPropagation();

      isFunction(onClickExtension) && onClickExtension();

      Wix.getPublicAPI(
        { appDefinitionId: SANTA_MEMBERS_APP_ID },
        (api) => {
          api
            .navigateToMember({
              memberSlug: get(user, 'slug'),
              memberId: get(user, 'siteMemberId'),
            })
            .catch(debug.error);
        },
        debug.error,
      );
    },
  }))(MembersAreaLink),
  SettingsLink: connect(() => ({
    appDefinitionId: SETTINGS_SECTION_APP_ID,
    sectionId: 'settings',
    to: '/',
    renderHref: false,
  }))(ExternalLink),
  NotificationsLink: connect(() => ({
    appDefinitionId: NOTIFICATIONS_SECTION_APP_ID,
    sectionId: 'notifications',
    to: '/',
    renderHref: false,
  }))(ExternalLink),
  navigateToMembers: () =>
    Wix.Utils.navigateToSection(
      {
        appDefinitionId: MEMBERS_SECTION_APP_ID,
        sectionId: 'all_members',
        shouldRefreshIframe: false,
      },
      '',
    ),
  navigateToProfile: (user) =>
    Wix.getPublicAPI(
      { appDefinitionId: SANTA_MEMBERS_APP_ID },
      (api) => {
        api
          .navigateToMember({
            memberSlug: get(user, 'slug'),
            memberId: get(user, 'siteMemberId'),
          })
          .catch(debug.error);
      },
      debug.error,
    ),
  navigateToProfileSettings: () =>
    Wix.Utils.navigateToSection(
      {
        appDefinitionId: SETTINGS_SECTION_APP_ID,
        sectionId: 'settings',
        shouldRefreshIframe: false,
      },
      '',
    ),
  navigateToNotifications: () =>
    Wix.Utils.navigateToSection(
      {
        appDefinitionId: NOTIFICATIONS_SECTION_APP_ID,
        sectionId: 'notifications',
        shouldRefreshIframe: false,
      },
      '',
    ),
  navigateToCreatePost: navigateToBlogOrPostPage,
  navigateToEditPost: navigateToBlogOrPostPage,
  navigateToMyDrafts: (user) =>
    Wix.getPublicAPI(
      { appDefinitionId: SANTA_MEMBERS_APP_ID },
      (api) => {
        api
          .navigateToSection({
            appDefinitionId: BLOG_APP_ID,
            appPageId: 'member-drafts-page',
            viewedUser: get(user, 'siteMemberId'),
          })
          .catch(debug.error);
      },
      debug.error,
    ),
};
